import {
  CompositeContextProvider,
  CompositeScopedContextProvider
} from "./5C7J4IAS.js";
import {
  createStoreContext
} from "./CFEUKV6C.js";

// src/toolbar/toolbar-context.tsx
var ctx = createStoreContext(
  [CompositeContextProvider],
  [CompositeScopedContextProvider]
);
var useToolbarContext = ctx.useContext;
var useToolbarScopedContext = ctx.useScopedContext;
var useToolbarProviderContext = ctx.useProviderContext;
var ToolbarContextProvider = ctx.ContextProvider;
var ToolbarScopedContextProvider = ctx.ScopedContextProvider;

export {
  useToolbarContext,
  useToolbarScopedContext,
  useToolbarProviderContext,
  ToolbarContextProvider,
  ToolbarScopedContextProvider
};
